import * as React from 'react'
import { DisplayContent, Plural, Singular } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import DaysSummary from './shared/DaysSummary'
import DepartureDateSummary from './shared/DepartureDate'
import ExcludedCitiesSummary from './shared/ExcludedCitiesSummary'
import NrPeopleSummary from './shared/NrPeopleSummary'

import { FunnelOrder } from '../../data/models/funnelOrder'
import { getRoomType, roomType } from '../../data/models/funnelOrder/roomType'
import { getDriveDestination } from '../../data/models/funnelOrder/summary'
import { getDriveSummaryContent } from '../../data/models/funnelOrder/theme'
import { AppState } from '../../data/state'
import NoteSummary from './shared/NoteSummary'

interface DriveSummaryProps {
  funnelOrder: FunnelOrder
  loading: boolean
  final?: boolean
}

const DriveSummary: React.FC<DriveSummaryProps> = ({
  funnelOrder,
  loading,
}) => {
  const summary = getDriveSummaryContent(funnelOrder.theme)
  const loadingClass = loading ? 'is-loading' : ''

  return (
    <>
      <NrPeopleSummary />
      <DepartureDateSummary />
      <DaysSummary
        contentKey={summary.contentKey}
        fallback={summary.fallback}
        getDestination={getDriveDestination}
        destination={funnelOrder.driveDestination}
      />
      <ListItem>
        <DisplayContent
          addNode
          contentKey="locations-summary"
          vars={{ locations: funnelOrder.locations.toString() }}
          plural={funnelOrder.locations > 1}
        >
          <Singular>{`${funnelOrder.locations} location`}</Singular>
          <Plural>{`${funnelOrder.locations} locations`}</Plural>
        </DisplayContent>
      </ListItem>
      <ExcludedCitiesSummary />
      <ListItem>
        <span className={loadingClass}>
          {getRoomType(funnelOrder.roomType)}&nbsp;
          {funnelOrder.roomType === roomType.premium ? (
            <DisplayContent contentKey="premium-accomodation-summary">
              hotel
            </DisplayContent>
          ) : (
            <DisplayContent contentKey="accomodation-summary">
              accomodation
            </DisplayContent>
          )}
        </span>
      </ListItem>
      <NoteSummary />
    </>
  )
}

export default connect((state: AppState) => ({
  funnelOrder: state.funnelOrder,
  loading: state.contentEngine.loading,
}))(DriveSummary)
